import { OpportunityIcon, SearchHelperPopup } from '@sales-center/components'
import Box from '@mui/material/Box'
import { selectCurrentUser } from '@user/store/authorization'
import { useGetUserBranchListOnMount } from '@user/store/authorization/hooks/useGetUserBranchListOnMount'
import { useSearchServiceLocations } from '@user/store/entityLocations'
import * as React from 'react'
import { FC } from 'react'
import { useSelector } from 'react-redux'
import { SearchBox } from './atoms'
import { getStyles } from './useStyles'
import { useTheme } from '@mui/material/styles'

type Props = {
  svcLocSearchState: ReturnType<typeof useSearchServiceLocations>
}

export const SelectLocationsHeader: FC<Props> = (props) => {
  const { svcLocSearchState } = props

  const currentUser = useSelector(selectCurrentUser)

  const branchListLoadStatus = useGetUserBranchListOnMount()

  const branchHelperText = React.useMemo(
    () =>
      currentUser.isAdmin
        ? 'all available branches which have corresponding Sales Teams'
        : `the following branches: ${currentUser.branches
            ?.map((x) => x.name)
            .join(', ')}`,
    [currentUser.branches, currentUser.isAdmin],
  )
  const styles = getStyles(useTheme())
  return (
    <>
      <SearchHelperPopup isLocationSearch />
      <Box display="flex" style={{ alignItems: 'center' }}>
        <Box sx={styles.icon}>
          <OpportunityIcon width={44} height={44} />
        </Box>
        <Box>
          <span style={styles.header}>Create Opportunity</span>
          <span style={styles.subHeader}>
            Search Names, Phone Numbers or Addresses
          </span>
        </Box>
      </Box>
      {branchListLoadStatus === 'success' && (
        <Box sx={styles.branchesDetails} display="flex">
          Based on your Branch / Sales Team access, search results are coming
          from&nbsp;
          {branchHelperText}
        </Box>
      )}
      <SearchBox {...svcLocSearchState} />
    </>
  )
}
